;!function(){try{var e="undefined"!=typeof window?window:"undefined"!=typeof global?global:"undefined"!=typeof globalThis?globalThis:"undefined"!=typeof self?self:{};e._sentryModuleMetadata=e._sentryModuleMetadata||{},e._sentryModuleMetadata[(new e.Error).stack]=Object.assign({},e._sentryModuleMetadata[(new e.Error).stack],{"_sentryBundlerPluginAppKey:localcoin":true});}catch(e){}}();import {
  AU_STATE_TO_SLUG_MAPPING,
  NZ_REGION_TO_SLUG_MAPPING,
  PL_REGION_TO_SLUG_MAPPING,
  PROVINCE_KEY_TO_SLUG_MAPPING,
} from '@/consts/api';
import { GetStateSlugParams } from '@/types/location';

export default function getStateSlug(location: GetStateSlugParams): string | undefined {
  switch (location.country) {
    case 'Canada':
      return PROVINCE_KEY_TO_SLUG_MAPPING[location.state];
    case 'Australia':
      return AU_STATE_TO_SLUG_MAPPING[location.state];
    case 'New Zealand':
      return NZ_REGION_TO_SLUG_MAPPING[location.state];
    case 'Poland':
      return PL_REGION_TO_SLUG_MAPPING[location.state];
    default:
      return PROVINCE_KEY_TO_SLUG_MAPPING[location.state];
  }
}
